import { startTransition } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useMenu } from '../../../utils/services/layoutService';
import MainLayout from './MainLayout';

const IbLayout = () => {
  const { lang } = useParams();
  const navigate = useNavigate();

  const { isLoadingHeaderAndMenu, dataHeaderAndMenu } = useMenu();
  if (!sessionStorage.getItem('refreshToken')) {
    startTransition(() => {
      navigate(`/${lang}/login`);
    });
  }

  // get_header_menu now returns the sidebar under `menu` instead of `main_menu`.
  // Normalize it so MainLayout keeps its `main_menu` contract.
  const layoutData = {
    ...dataHeaderAndMenu,
    main_menu: dataHeaderAndMenu?.menu,
  };

  return <MainLayout data={layoutData} isLoading={isLoadingHeaderAndMenu} isMaintainable />;
};

export default IbLayout;
